import { useCallback } from 'react';

import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { useLoyaltyContext } from '@fhs-legacy/frontend/src/state/loyalty';
import { usePaymentContext } from '@fhs-legacy/frontend/src/state/payment';
import { mapPaymentMethodToLoyaltyPaymentMethods } from '@fhs-legacy/frontend/src/utils/payment';

export function useReevaluateOffersOnPickupTimeChange() {
  const { cartEntries, calculatedCartTotal } = useCartContext();
  const { checkoutPaymentMethod } = usePaymentContext();
  const { evaluateLoyaltyUserIncentives } = useLoyaltyContext();
  const { appliedLoyaltyOffers, appliedRewards, loyaltyId, incentiveSelections } = useAppSelector(
    state => ({
      appliedLoyaltyOffers: selectors.loyalty.selectAppliedOffers(state),
      appliedRewards: selectors.loyalty.selectAppliedLoyaltyRewards(state),
      loyaltyId: selectors.loyalty.selectLoyaltyUserId(state),
      incentiveSelections: selectors.loyalty.selectSelectedOfferSelections(state),
    })
  );

  return useCallback(
    (pickUpTime?: string) => {
      if (appliedLoyaltyOffers.length === 0) {
        return;
      }

      const paymentMethod = mapPaymentMethodToLoyaltyPaymentMethods(checkoutPaymentMethod);
      evaluateLoyaltyUserIncentives({
        loyaltyId,
        appliedLoyaltyOffers,
        cartEntries,
        appliedRewards,
        subtotalAmount: calculatedCartTotal,
        paymentMethod,
        skipTimeValidation: false,
        pickUpTime,
        incentiveSelections,
      });
    },
    [
      appliedLoyaltyOffers,
      appliedRewards,
      calculatedCartTotal,
      cartEntries,
      checkoutPaymentMethod,
      evaluateLoyaltyUserIncentives,
      incentiveSelections,
      loyaltyId,
    ]
  );
}
